import MainApi from "../../../MainApi";
import { more_from_store } from "../../../ApiRoutes";
import { useQuery } from "react-query";
import { onErrorResponse } from "../../../api-error-response/ErrorResponses";

const getData = async (pageParams) => {
  const { productId, offset, limit } =
    pageParams;
  if (!productId) {
    throw new Error('Product ID is required');
  }
  const { data } = await MainApi.get(
    `${more_from_store}/${productId}?offset=${offset}&limit=${limit}`
  );
  return data;
};

export default function useGetMoreFromStores(pageParams, handleSuccess) {
  return useQuery("stores-categories-item", () => getData(pageParams), {
    enabled: false,
    onSuccess: handleSuccess,
    onError: onErrorResponse,
    retry: false,
  });
}
